/**
 * @since 0.14.0
 * @visibleName FONT_FAMILIES
 * @component
 */
export default {
  MONTSERRAT: 'Montserrat, Arial black, sans-serif',
  OPEN_SANS: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
} as const;
